export default "__VITE_ASSET__EEiTBECu__"